import React, { FC, useMemo } from 'react'
import { Box, IconButton, Typography } from '@mui/material'
import theme from 'theme'

/* Components */
import { Container } from './integrationHeader.styles'
import ThemeButton from '../buttons/primary/ThemeButton'
// import SaveSvg from '../svg/labels/SaveSvg'
import { TestStatus } from '../../pages/settings/integrations/SetupIntegrationInstance'
import { PermissionTooltip } from '../tooltip'
import { disabledStyles } from '../buttons'

interface Props {
  headerTitle: string
  handleSave: () => void
  handleDiscard: () => void
  handleBack?: () => void
  testStatus?: any
  isSubmitting?: any
  isValid?: any
  loading?: any
  schema?: any
  allowSave?: boolean
  discardDisabled: boolean
  noEditPermission: boolean
  /* When given, it alone decides Save; the connection-test rule below is skipped. */
  saveDisabled?: boolean
}

const IntegrationHeader: FC<Props> = ({
  headerTitle,
  handleSave,
  testStatus,
  isSubmitting,
  isValid,
  loading,
  schema,
  handleDiscard,
  handleBack,
  discardDisabled,
  allowSave,
  noEditPermission,
  saveDisabled
}) => {
  const disabled = useMemo(() => {
    if (typeof saveDisabled !== 'undefined') return saveDisabled
    if (testStatus !== TestStatus.successful) return true
    if (allowSave) return loading || !isValid || !schema || isSubmitting
    if (!allowSave) return true

    return loading || !isValid || !schema || isSubmitting
  }, [saveDisabled, testStatus, allowSave, loading, isValid, schema, isSubmitting])

  return (
    <Container className="integration-header-container">
      <Box className="integration-header-wrapper">
        {typeof handleBack !== 'undefined' && (
          <Box className="back-arrow-wrapper">
            <IconButton onClick={handleBack}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="-6.5 8 24 24" fill="none">
                <path
                  d="M9 27.5L2 20L9 12.5"
                  stroke="#D0C3CC"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </IconButton>
          </Box>
        )}

        <Box className="header-content">
          <Typography className="header-title">{headerTitle}</Typography>
        </Box>

        <Box className="header-actions">
          {noEditPermission ? (
            <PermissionTooltip
              PopperProps={{
                sx: {
                  marginTop: `-${theme.spacing.sm}px !important`
                }
              }}
              title={
                <>
                  <Box className="tooltip-wrapper-permissions">
                    <Typography className="tooltip-text">Insufficient permissions</Typography>
                  </Box>
                </>
              }
            >
              <ThemeButton
                themevariant="secondary"
                sx={{ ...disabledStyles.secondary, fontSize: '14px !important' }}
                className="cancel-button"
              >
                Cancel
              </ThemeButton>
            </PermissionTooltip>
          ) : (
            <ThemeButton
              themevariant="secondary"
              onClick={handleDiscard}
              disabled={discardDisabled}
              className="cancel-button"
            >
              Cancel
            </ThemeButton>
          )}

          {noEditPermission ? (
            <PermissionTooltip
              PopperProps={{
                sx: {
                  marginTop: `-${theme.spacing.sm}px !important`
                }
              }}
              title={
                <>
                  <Box className="tooltip-wrapper-permissions">
                    <Typography className="tooltip-text">Insufficient permissions</Typography>
                  </Box>
                </>
              }
            >
              <ThemeButton themevariant="primary" sx={disabledStyles.secondary} className="save-button">
                Save
              </ThemeButton>
            </PermissionTooltip>
          ) : (
            <ThemeButton themevariant="primary" onClick={handleSave} disabled={disabled} className="save-button">
              Save
            </ThemeButton>
          )}
        </Box>
      </Box>
    </Container>
  )
}

export default IntegrationHeader
